import { useStore as useReduxStore } from 'react-redux';
import { Action, Store } from '@reduxjs/toolkit';

import { RootState } from '../store/rootReducer';

const useStore = (): Store<RootState, Action> => useReduxStore<RootState>();

export default useStore;
